import React, { useState } from 'react';

import { type TPandasDataFrameDict } from '../../components/TPandasDataFrameDict';
import Page from '../../components/layout/Page';
import { ETableIds } from '../../enums/ETableIds';
import { type PaginationMeta } from '../../models/GhostPostModel';
import { type ISortingMeta } from '../../models/ISortingMeta';
import CBrowsableTable from './CBrowsableTable';

type TableMeta = Partial<{
  sorting: ISortingMeta;
  pagination: PaginationMeta;
  search: string;
}>;

export function PPlaygroundIndex3() {
  const [, setMeta] = useState<TableMeta>({
    sorting: {
      sortCol: 0,
      ascending: 'ascending'
    },
    pagination: {
      page: 1,
      pages: 1,
      total: 3,
      limit: 10,
      prev: null,
      next: null
    }
  });

  const data: TPandasDataFrameDict = {
    Name: {
      '0': 'Alex',
      '1': 'Ben',
      '2': 'Chris'
    },
    Role: {
      '0': 'Admin',
      '1': 'Staff',
      '2': 'User'
    },
    Age: {
      '0': 28,
      '1': 31,
      '2': 24
    }
  };

  return (
    <Page title={'Playground 3'}>
      <CBrowsableTable
        id={ETableIds.PLAYGROUND_BROWSABLE}
        data={data}
        state={{ isError: false, isLoading: false }}
        tableMeta={undefined}
        onUpdateTableMeta={(nextMeta) => {
          setMeta(nextMeta);
          console.log('CTableBrowsable meta changed:', nextMeta);
        }}
        cacheEpochInSeconds={Date.now()}
        rowConfig={{}}
        columnConfig={[
          {
            span: 1
          },
          {
            span: 1,
            body: {
              style: () => ({
                textAlign: 'center'
              })
            }
          },
          {
            span: 1,
            body: {
              style: () => ({
                textAlign: 'center'
              })
            }
          }
        ]}
        onUpdateInternalState={() => {}}
      />
    </Page>
  );
}
